module.exports = __webpack_public_path__ + "img/order_reservation.54ff3db4.svg";